<template>
    <div class="position-relative" id="what-we-do">
        <div class="pin-whatwedo text-white bg-black">
            <div class="pin-content" id="pin-content">
                
                <b-row id="pinned-section" class="scroll-section py-100 px-60">
                    <b-col lg="4" class="">
                        <div class="h1 ga-pink gotham-book">
                            WHAT WE DO
                        </div>
                        <div class="section-counter gotham-light">
                            <div>
                                {{currentListItem}} / 12
                            </div>
                        </div>
                    </b-col>
                    <b-col lg="8" >
                        <div id="text-items" class="gotham-light">
                            <ul>
                                <li 
                                class="listed-item d-flex" 
                                v-for="(item,i) in slides" :key="i">
                                <div>___</div>
                                <div class="ml-4">
                                    <p class="h2 gotham-bold">
                                        {{ item.heading }}
                                    </p>
                                    <p class="h3 gotham-book">
                                        {{ item.subheading }}
                                    </p>
                                    <p class="h5 gotham-light">
                                        {{ item.description }}
                                    </p>
                                </div>
                                </li>
                            </ul>
                            <div class="custom-pin-spacer"></div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default {
    data() {
        return {
            currentListItem: 0,
            whatWeDo_scrollPin: null,
            list_item_animation: null,
            slides: [
                {
                    heading: "project & corporate identity creation",
                    subheading: "Existing Eye Offerings",
                    description: "We build brands from the ground-up, while developing existing brands to reach their full potential. With a keen eye for striking design, in-depth research, and a unique voice for every brand we build and develop, we continue to create distinctive offerings that truly drive success."
                },
                {
                    heading: "print ad",
                    subheading: "People Print Dollars",
                    description: "Some people say print ads aren't worth the marketing dollars they generate. Those are the same people who don't know how to do it right. Print ads may be a forgotten art in today's digital age, but they still remain an immensely powerful tool to have in your toolbox. And we've been practicing since the 1980's. "
                },
                {
                    heading: "brochure design",
                    subheading: "Capture Invite Influence",
                    description: "When it comes to creating award-winning brochures, we do it by the book. Carefully considering every detail to produce engaging and informative pieces that capture your viewer's attention, and invites them in to discover something more. An indispensable resource that directly influences sales time after time."
                },
                {
                    heading: "direct mail designs & delivery",
                    subheading: "Egyptian Landowner Papyrus",
                    description: "Ah, print and digital direct mail. The lifeblood of advertising since 1000 B.C., when an Egyptian landowner scribbled an unsavory advertisement on a piece of papyrus. We've come a long way since then no doubt, but the power and application of this timeless marketing method remains. Only now, we can generate thousands of sales and even more leads faster than ever before. Sounds easy, right?"
                },
                {
                    heading: "website design & development",
                    subheading: "Wizards Bring Life",
                    description: "Our expert web team, or Web Wizards as we call them, handle everything throughout the development, management, and maintenance processes. They work closely alongside our designers and writers to bring the visions of your ideal website to life. With creation and hosting all done in-house, it's the one-stop-shop for all your website needs."
                },
                {
                    heading: "social media/content",
                    subheading: "Fingers Pulse Everything",
                    description: "The heart and soul of any contemporary campaign, our social media experts have their fingers on the pulse of everything #trending. From punchy, attention-grabbing posts to strategic planning, in-depth market research and more, our dedicated social team really does do it all."
                },
                {
                    heading: "marketing & digital advertising",
                    subheading: "Love Secret Strategies",
                    description: "Marketing is our first love, and in this day and age, digital advertising is our secret weapon. From proven far-reaching marketing strategies to Search Engine Optimization, curated digital ads, Google adwords, video ads, and more, our digital campaigns are award-winning. "
                },
                {
                    heading: "production, installation & fabrication",
                    subheading: "Relish Ketchup Mustard",
                    description: "We've got an actual workshop downstairs. That's how 'full-service' we are. With an in-house Production, Installation & Fabrication team dedicated to building the retail spaces and presentations centres of your dreams, we relish the opportunity to pursue your greatest ambitions. That might sound a little cheesy, but hey, we're one ketchup and mustard pun away from making you a burger."
                },
                {
                    heading: "media planning",
                    subheading: "Mr. T Planned Goals",
                    description: "We're not the only ones who love it when a plan comes together, Mr. T does too. Because, like us, he knows the importance and power a properly planned media schedule has on overall engagement and sales. Which is why we work closely alongside you to create effective plans that go beyond fulfilling your brand goals."
                },
                {
                    heading: "interior design & décor consulting",
                    subheading: "Interior Visceral Cutting",
                    description: "Our accredited team of interior designers has created and decorated some of the GTA's most-striking retail spaces, presentation centres, and custom homes. Their impeccable style and love for turning blank spaces into visceral experiences keeps them on design's cutting edge. "
                },
                {
                    heading: "signage design",
                    subheading: "Art Rooted Demands",
                    description: "Signs, signs, everywhere there's signs! We've mastered the art of all forms of signage, plain and simple. It starts with a comprehensive strategic plan rooted in location. Then, we hone in on your brand voice, target demographic, and primary messaging. Adding creativity before bringing to a simmer, and your left with a powerful, engaging, and concise deliverable that demands attention while educating the viewer. "
                },
                {
                    heading: "renderings",
                    subheading: "Play Services Request ",
                    description: "Our rendering services go beyond simple coordination. They play a crucial part in the conceptualization, design, and realization of your project vision. From interior retail space renderings to pre-construction architectural depictions, we  provide high-quality and cost-effective services to create inspiring marketing deliverables. Whether an asset within a comprehensive campaign or a standalone request, we do our utmost to ensure every one of our renderings meets the highest standards of excellence and accuracy. "
                }
            ]
        }
    },
    mounted() {
        const text_items = document.getElementById("text-items");

        const tweenOne = gsap.to(text_items, {
            y: 500 - text_items.clientHeight,
            // yPercent: -100,
            scrollTrigger: {
                trigger: "#pinned-section",
                pin: "#pinned-section",
                pinSpacing: false,
                scrub: true,
                start: "top top",
                end: () => "+=" + (text_items.clientHeight + 200),
            }
        });

        const pinnedContent = document.getElementById("pin-content");

        let list_items = document.querySelectorAll(".listed-item");
        let _this = this;

        list_items.forEach((item) => {
            let list_item_animation = this.list_item_animation;
            gsap.fromTo(item, {opacity: 0.3}, {
                scrollTrigger: {
                    trigger: item,
                    start: "-200 center",
                    end: "40% center",
                    scrub: true,
                    onToggle(self) {
                        if(self.direction == 1 && self.isActive) {
                            _this.currentListItem += 1
                        } else if(self.direction == -1 && !self.isActive) {
                            _this.currentListItem -= 1
                        }
                    },
                },
                duration: 0.2,
                opacity: 1,
                immediateRender: false,
            })
        });

    }
}
</script>

<style lang="scss">
#what-we-do {

    .pin-whatwedo {

        .pin-content {
            overflow: hidden;
            height: 100%;
            
        }
    }

    #pinned-section {
        .section-counter {
            position: fixed;
            height: 100vh;
            top: 0;
            color: #fff;
            font-size: 7rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
    }

    #text-items {
        ul {
            font-size: 4rem;
            .listed-item {
                padding-top: 120px;
                opacity: 0.3;
            }
        }
    }

    .custom-pin-spacer {
        height: 200px;
        width: 100%;

        @media screen and (max-width: 1400px) {
            height: 300px;
        }
    }

    .big-text {
        font-size: 5rem;
    }

    // .scroll-section {
    //     max-height: 100% !important;
    //     height: 100% !important;
    // }

    .card {
        position: relative;
        border: 0;
        background: transparent;
        border-radius: unset;

        .tab-content {
            display: flex;

            .active {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        }

        .pink-divider {
            background: #ff56b1;
            width: 2px;
            height: 100%;
            position: absolute;
            left: 50%;
            top: 0;
        }

        .nav-pills {
            padding: 0 1.25rem;

            .nav-item {

                a {
                    background: transparent;
                    position: relative;
                    color: #ff56b1;
                    font-size: 1.25rem;
                }
                .nav-link {
                    padding: 0 1rem;
                    margin: 6px 0;
                }

                .nav-link.active {
                    color: #fff;

                    .list-bullet {
                        position: absolute;
                        top: 11px;
                        left: -24px;
                        background: #fff;
                        width: 10px;
                        height: 10px;
                        border-radius: 50%;
                    }
                }
            }
        }
    }

    

    
}
</style>